
<template>
	<div>
		<canvas :id="id">
			Your browser does not support the canvas element.
		</canvas>
	</div>
</template>

<script>
export default {
  props: {
		data_ex:{
			default: () => [],
		},
    onClick: {
      default: () => () =>{ },
    },
    id: {require: true},
    legendDisplay: {default: true},
    data:{default: () => []},
    colors:{default: () => []},
    borderColor:{},
    fontColor: {
      default: 'black'
    },
    labels:{default: () => []},
    gauge:{default:0},
		l1:{default:''},
		l2:{default:''},
  },
  data() {
    return {
      myDoughnutChart:'',
      flag_1:false,
    };
  },
  watch: {
		gauge(v) {this.load()},
    data(v) {this.load()},
    data_ex(v) {this.load()},
    labels(v){this.load()},
  },
  mounted(){
    this.load();
  },
  methods: {
    load(){
      const {onClick} = this;
      const Chart = require('chart.js');

      const ctx = document.getElementById(this.id).getContext('2d');
      if (this.myDoughnutChart.destroy) this.myDoughnutChart.destroy();
      const {drawNeedle,l1,l2} = this;
			const $this = this;
      this.myDoughnutChart = new Chart(ctx, {
        type: 'doughnut',
				plugins: [{
					afterDraw: chart => {
						const needleValue = this.gauge;
						const dataTotal = chart.chart.config.data.datasets[0].data.reduce((a, b) => a + b, 0);
						const angle = (Math.PI*0.93) + ((1) / dataTotal * needleValue * (Math.PI * 1.14));
						
						const ctx = chart.chart.ctx;
						const cw = chart.chart.canvas.offsetWidth;
						const ch = chart.chart.canvas.offsetHeight;
						const cx = cw / 2;
						const cy = ch - 6 -30;
						const thick = 15;
						ctx.translate(cx, cy);
						ctx.rotate(angle);
						ctx.beginPath();
							ctx.moveTo((thick-10), -(thick));
							ctx.lineTo(parseInt(ch*0.4), 0);
						ctx.lineTo((thick-10), parseInt(thick));
						ctx.fillStyle = 'rgb(0, 0, 0)';
						ctx.fill();
						ctx.rotate(-angle);
							ctx.translate(-cx, -(cy));
						ctx.beginPath();
							ctx.arc(cx, cy, thick, 0, Math.PI * 2);
						ctx.fill();

						const {height,width} = chart.chart;
						//ctx.restore();
						const fontSize_2 = (height / 164).toFixed(2);
						ctx.font = 'bold '+fontSize_2 + "em sans-serif";
						ctx.fontcolor = "grey";
						ctx.textBaseline = "middle";
						
						
						
						const textY = height / 1.8;
						ctx.fillStyle = "#999999";
						if (l1) ctx.fillText(l1, Math.round((width - ctx.measureText(l1).width) / 2), textY);
						if (l2) ctx.fillText(l2, Math.round((width - ctx.measureText(l2).width) / 2), textY+25);
						/* ctx.save(); */

 						//const {ctx}	= $this.myDoughnutChart;
							ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontFamily, 'normal', Chart.defaults.global.defaultFontFamily);
							ctx.textAlign = 'left';
							ctx.textBaseline = 'bottom';
							
							const fontSize = (height / 220).toFixed(2);
							const lessx = parseFloat((width / 16).toFixed(2))
    					ctx.font = fontSize + "em sans-serif";
							const {data_ex} = $this.myDoughnutChart;

							$this.myDoughnutChart.config.data.datasets.forEach(function (dataset) {
								for (var i = 0; i < dataset.data.length; i++) {
									var model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model,
											//total = dataset._meta[Object.keys(dataset._meta)[0]].total,
											mid_radius = model.innerRadius + (model.outerRadius - model.innerRadius)/2,
											start_angle = model.startAngle,
											end_angle = model.endAngle,
											mid_angle = start_angle + (end_angle - start_angle)/2;

									var x = mid_radius * Math.cos(mid_angle);
									var y = mid_radius * Math.sin(mid_angle);

									ctx.fillStyle = '#fff';
									if (i == 3){ // Darker text color for lighter background
										ctx.fillStyle = '#444';
									}
									//var percent = String(Math.round(dataset.data[i]/total*100)) + "%";      
									//Don't Display If Legend is hide or value is 0
									//console.log(data_ex,dataset.data,{i,model,lessx},chart.chart.width);

									if(dataset.data[i] != 0 /* && (dataset._meta[0] && (dataset._meta[0].data[i].hidden == undefined || dataset._meta[0].data[i].hidden == false)) */) {
										//ctx.fillText(`${dataset.data[i]}AA`, model.x + x -lessx, model.y + y);
										// Display percent in another line, line break doesn't work for fillText
										//ctx.fillText(percent, model.x + x -lessx, model.y + y + 18);

										if(data_ex[i] && data_ex[i].l1) ctx.fillText(data_ex[i].l1, model.x + x -lessx, model.y + y);
										if(data_ex[i] && data_ex[i].l2) ctx.fillText(data_ex[i].l2, model.x + x -lessx, model.y + y + 18);
									}
								}
							}); 
					},
				}],
        data: {
          labels: this.labels,
          datasets: [
            {
              data: this.data,
              labels: this.labels,
      				needleValue: 30,
              backgroundColor: this.colors,
              borderWidth:10,
              /* borderColor: this.borderColor || this.colors, */
            	weight:1,
          		hoverOffset: 4
            },
          ]
        },
        options:{
          cutoutPercentage: 60,
					rotation: -1.0 * Math.PI , // start angle in radians
					circumference: Math.PI , // sweep angle in radians
					onClick,    
					tooltips: {enabled: false},
					hover: {mode: null},
          animation:{
            animateRotate: false,
            onComplete: function () { }
          },
          legend: {
						display: this.legendDisplay,
						position: 'top',
						/* labels: {fontColor: this.fontColor} */
          },
        },
      });
			this.myDoughnutChart.data_ex = this.data_ex;
      this.myDoughnutChart.aspectRatio = 2;
    },
  }, // methods
};
</script>
